import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';

// "Birey ile giriş yapıldı, ancak bryekosis LMS erişiminiz yok" — shown when a user
// authenticates via Birey but their kurum isn't entitled to Digipo. Mirrors
// Sınav.Link's /erisim-yok so the no-access experience is consistent across products.
const ErisimYok: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const ad = searchParams.get('ad');
  const BIREY_LOGOUT = `${process.env.REACT_APP_BIREY_ISSUER || 'http://localhost:8790'}/oauth/logout`;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#fafafa] px-4 py-12">
      {/* 44px — under the wordmark's legibility floor, so the LMS mark alone. */}
      <BrandLogo variant="mark" className="h-[44px] object-contain mb-8" />

      <div className="w-full max-w-[460px] rounded-[20px] border border-[#e6e9ef] bg-white p-8 text-center shadow-[0_18px_50px_rgba(20,30,50,0.08)]">
        <div className="mx-auto mb-5 grid h-14 w-14 place-items-center rounded-full bg-amber-50">
          <svg
            width="26"
            height="26"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#d97706"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden={true}
          >
            <rect x="3" y="11" width="18" height="11" rx="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>

        <span className="mb-3 inline-block rounded-full bg-emerald-50 px-3 py-1 text-[12px] font-bold text-emerald-600">
          Birey ile giriş yapıldı ✓
        </span>

        <h1 className="text-[20px] font-bold text-[#2b2b2b]">bryekosis LMS erişiminiz yok</h1>

        <p className="mt-3 text-[14px] leading-relaxed text-[#5b6472]">
          {ad ? `${ad} olarak ` : ''}Birey hesabınızla başarıyla giriş yaptınız, ancak kurumunuzun{' '}
          <b className="text-[#2b2b2b]">bryekosis LMS</b> erişimi bulunmuyor.
        </p>
        <p className="mt-2 text-[13px] text-[#8a93a2]">
          Erişim için lütfen kurum yöneticinizle iletişime geçin.
        </p>

        <div className="mt-6 flex flex-col items-center gap-3">
          <button
            type="button"
            onClick={() => navigate('/login')}
            className="w-full rounded-[14px] bg-[#3973bf] py-3 text-[14px] font-semibold text-white transition-colors hover:bg-blue-700"
          >
            Giriş sayfasına dön
          </button>
          <a
            href={BIREY_LOGOUT}
            className="text-[13px] font-semibold text-[#5b6472] no-underline hover:text-[#2b2b2b]"
          >
            Farklı bir hesap kullan
          </a>
        </div>
      </div>

      <p className="mt-6 text-center text-[12px] text-[#8a93a2]">© 2026 bryekosis LMS</p>
    </div>
  );
};

export default ErisimYok;
